// src/components/common/SyncAlertBanner.js
//
// Unmissable, full-width banner shown to a tournament director when their edits
// are NOT reaching the server (stuck writes or offline with unsynced changes).
// The sync-status LED is a tiny dot a non-technical director will miss; a bar
// they can't miss prompts them to fix connectivity. Reloading is a LOSSLESS
// recovery — queued writes persist in Firestore's IndexedDB cache across a
// reload and re-flush once the connection/token is healthy again.

import React from 'react';

export default function SyncAlertBanner({ offline = false, onReload }) {
  return (
    <div
      role="alert"
      style={{
        position: 'fixed',
        top: 64, // sits just under the 64px top nav
        left: 0,
        right: 0,
        zIndex: 3000,
        backgroundColor: 'var(--danger, #ef4444)',
        color: '#fff',
        padding: '10px 16px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 16,
        flexWrap: 'wrap',
        boxShadow: '0 2px 10px rgba(0,0,0,0.25)',
        fontFamily: 'var(--font-body, sans-serif)',
        fontSize: 14,
      }}
    >
      <span style={{ fontWeight: 700, textAlign: 'center' }}>
        ⚠️ Your changes are NOT being saved
        {offline ? ' — you appear to be offline.' : ' — the connection to the server is stuck.'}
        {' '}Check your internet (move closer to the router or use a phone hotspot).
      </span>
      {onReload && (
        <button
          onClick={onReload}
          title="Your entered scores are saved on this device and will not be lost by reloading."
          style={{
            flexShrink: 0,
            padding: '8px 16px',
            borderRadius: 8,
            border: 'none',
            backgroundColor: '#fff',
            color: 'var(--danger, #ef4444)',
            fontWeight: 800,
            fontSize: 14,
            cursor: 'pointer',
            whiteSpace: 'nowrap',
          }}
        >
          Reconnect &amp; Reload
        </button>
      )}
    </div>
  );
}
